import { Checkbox } from "@mui/material";
import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import LocalService from "service/patrimonio/LocalService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const localService = new LocalService();

export default function LocalListagem() {


    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    

    return (

        <BaseListagem ordenacao="id,ASC" service={localService} urlService="/local" tituloPagina={'Locais'} defaultFilters={defaultFilters} showClearFilterButton nome="local" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} 
                headerStyle={{ width: "25%" }} />
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} 
                headerStyle={{ width: "100%" }} />
            <Column field="ativo" header="Ativo" style={{ width: '5em', textAlign: "center" }} body={(rowData)=><Checkbox checked={rowData.ativo} />} />
        </BaseListagem>
    )
}
